<template>
    <div class="schedule-vue-sample" style="height:100%;">
        <ejs-schedule ref='scheduleObj' id='Schedule' height="100%" :selectedDate='selectedDate'
            :eventSettings='eventSettings' :actionComplete="onActionComplete" :eventRendered="onEventRendered"
            :enableAdaptiveUI="enableAdaptiveUI">
            <e-views>
                <e-view option="Month"></e-view>
            </e-views>
        </ejs-schedule>
    </div>
</template>

<script>
/*eslint-disable */

import { Agenda, Day, Month, SchedulePlugin, Week, WorkWeek } from '@syncfusion/ej2-vue-schedule';

import Vue from "vue";
import {
    mapGetters
} from 'vuex';

Vue.use(SchedulePlugin);
export default {
    name: 'scheduler-data',
    components: {
    },
    props: [],
    data() {
        return {
            selectedDate: new Date(),
            readonly: false,
            eventSettings: {
                dataSource: this.generateData(),
            },
            currentView: 'Month',
            enableAdaptiveUI: false,
            currentUserId: ''
        }
    },
    provide: {
        schedule: [Month]
    },
    computed: {
        ...mapGetters([
            'getSchedulerListGetter'
        ]),
    },
    mounted() {
        this.currentUserId = localStorage.getItem('LoginedUserID');
    },
    methods: {
        onEventRendered(args) {
            if (args.data.Description == 'Appointment Scheduled') {
                (args.element).style.backgroundColor = '#F57F17';
            } else if (args.data.Subject == 'Demo Request') {
                (args.element).style.backgroundColor = '#b41818';
            } else if (args.data.Subject == 'Lymphomap Meeting') {
                (args.element).style.backgroundColor = '#ff0b00';
            }
        },
        generateData() {
            var collections = [];
            var dataCollections = [this.$store.getters.getSchedulerListGetter];
            for (var i = 0; i < dataCollections.length; i++) {
                collections = collections.concat(dataCollections[i]);
            }
            return collections;
        },
        onActionComplete(event) {
            if (event.requestType == 'eventCreated') {
                var CreateEventId = this.currentUserId + event.data[0].Id
                let data = {
                    Subject: event.data[0].Subject,
                    StartTime: event.data[0].StartTime,
                    EndTime: event.data[0].EndTime,
                    Id: CreateEventId,
                    Description: event.data[0].Description,
                    StartTimezone: event.data[0].StartTimezone,
                    EndTimezone: event.data[0].EndTimezone
                }
                this.$store.dispatch('createSchedulerDetailsAction', data).then((res) => {
                    this.getSchedulerListAgain()
                })
            } else if (event.requestType == 'eventRemoved') {
                if (event.deletedRecords[0].user) {
                    var RemoveEvtId = event.deletedRecords[0].Id
                    this.$store.dispatch('removeSchedulerDetailsAction', { id: RemoveEvtId }).then((res) => {
                        this.getSchedulerListAgain()
                    })
                } else {
                    var RemoveEvtId = this.currentUserId + event.deletedRecords[0].Id
                    this.$store.dispatch('removeSchedulerDetailsAction', { id: RemoveEvtId }).then((res) => {
                        this.getSchedulerListAgain()
                    })
                }
            } else if (event.requestType == 'eventChanged') {
                let udata = {
                    Subject: event.data[0].Subject,
                    StartTime: event.data[0].StartTime,
                    EndTime: event.data[0].EndTime,
                    Description: event.data[0].Description,
                    StartTimezone: event.data[0].StartTimezone,
                    EndTimezone: event.data[0].EndTimezone
                }
                if (event.data[0].user) {
                    var UpdateEventId = event.data[0].Id
                } else {
                    var UpdateEventId = this.currentUserId + event.data[0].Id
                }
                this.$store.dispatch('updateSchedulerDetailsAction', { data: { data: udata, id: UpdateEventId } }).then((res) => {
                    this.getSchedulerListAgain()
                })
            }
        },
        getSchedulerListAgain() {
            this.$store.dispatch('getSchedulerListAction')
        },
    }
}
</script>
<style lang="scss" scoped>
@import '../../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';
@import url('../../../../assets/css/scheduler.css');

.e-control {
    font-family: -apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Roboto, sans-serif;
}

::v-deep .e-schedule {
    border: none;
    background: #111111;
    color: #f1f3f7;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);

    /* 1. Header Toolbar */
    .e-schedule-toolbar {
        background-color: rgba(12, 13, 18, 0.7) !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.02) !important;
        margin-bottom: 0px !important;
        backdrop-filter: blur(20px);
        min-height: 32px !important;
        padding: 5px 15px !important;

        .e-toolbar-items {
            background-color: transparent !important;
            height: auto;
            min-height: inherit;
        }

        .e-toolbar-item button {
                border-radius: 5px !important;
                border: 1px solid rgba(255, 255, 255, 0.02);
                background: rgba(255, 255, 255, 0.04) !important;
                color: #94a3b8 !important;
                height: 26px !important;
                padding: 0 5px !important;
                transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
                .e-tbar-btn-text,
                .e-icons{
                    color: inherit !important;
                }
        }

        .e-toolbar-item.e-active button,
        .e-toolbar-item button:hover {
               background: rgba(255, 255, 255, 0.09) !important;
                border-color: rgba(255, 255, 255, 0.16) !important;
                color: #ffffff !important;
                transform: translateY(-1px) !important;
        }
    }

    /* 2. Schedule Table / Month Grid Header (Days of week) */
    .e-schedule-table {
        border-color: rgba(255, 255, 255, 0.02) !important;
        background-color: #0b0c10 !important;
        backdrop-filter: blur(20px);
    }

    .e-date-header-wrap table td {
        background-color: rgba(33, 36, 48, 0.6) !important;
        color: #94a3b8 !important;
        backdrop-filter: blur(20px);
        border-color: rgba(255, 255, 255, 0.02) !important;
        font-weight: 600;
        backdrop-filter: blur(20px);
    }


    /* 3. Schedule Body Cells */
    .e-work-cells,
    .e-month-view .e-work-cells {
        background-color: #20222b !important;
        border-color: rgba(255, 255, 255, 0.02) !important;
        backdrop-filter: blur(20px);
        color: #e6edf3 !important;

        /* Other month cells / Dimmed dates */
        &.e-other-month {
            background-color: #23252d !important;
            color: #4b5563 !important;
            & .e-navigate,
            & .e-date-header {
                color: #4b5563 !important;
            }
        }

        &:hover {
            background-color: #121824 !important;
        }
    }

    /* 4. Date Numbers / Headers inside Cells */
    .e-date-header,
    .e-navigate {
        color: #c9d1d9 !important;
    }

    /* Today Highlight */
    .e-current-date,
    .e-current-day {
        color: #58a6ff !important;
    }

    /* 5. More Events popup / Dropdown indicator */
    .e-more-indicator {
        color: #58a6ff !important;
    }

    /* 6. Appointments / Event Cards */
    .e-appointment {
        border-radius: 6px !important;
        border: 1px solid rgba(255, 255, 255, 0.08) !important;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.4);
        background: #ffe738;
        color: #22292f;
        font-weight: 600;

        .e-subject {
            color: inherit !important;
            font-weight: 600 !important;
        }
    }
    .e-month-view .e-current-date .e-date-header, .e-month-agenda-view .e-current-date .e-date-header{
        background-color: rgba(33, 228, 0, 0.12) !important;
        color: #21e400 !important;
    }
}

</style>